import { applyChallengeEvent } from './payment-lifecycle.js';
/** Only provider-supplied requirements/challenges or supported authentication offer recovery. */
export function limitVerificationRoute(discovery, review) {
    if (review?.challenge)
        return 'quote_challenge';
    const verification = discovery?.customerVerification;
    if (verification &&
        (verification.challenge || ['collecting', 'not_created'].includes(verification.status)))
        return 'customer_verification_required';
    if (discovery?.guest && discovery.methods.length > 0)
        return 'connect_requested';
    return null;
}
export function fundingLimitActions(options) {
    const { state, review, discovery, progress, navigation, busy, attemptId } = options;
    const blocked = (state === 'amount' || state === 'review') && review?.state === 'limit_exceeded';
    const route = blocked ? limitVerificationRoute(discovery, review) : null;
    return {
        limitRecovery: { blocked, canVerify: route !== null && !attemptId },
        verifyLimits() {
            if (!route || busy || attemptId || navigation.getSnapshot().attempted)
                return;
            options.beforeVerify?.();
            progress.verificationFromLimit = true;
            progress.verificationFromProfile = false;
            if (route === 'quote_challenge' && review?.challenge)
                options.setChallengeUrl(review.challenge.url);
            navigation.transition(route);
        },
    };
}
/** Returning never retains a quote as payment authority or discards the amount/method. */
export function returnFromLimitVerification(progress, navigation, attemptId, completed = false) {
    if (!progress.verificationFromLimit || attemptId)
        return false;
    progress.verificationFromLimit = false;
    navigation.transition(completed ? 'limit_verification_complete' : 'limit_verification_return');
    return true;
}
/** A completed frame may still report pending/rejected KYC, or a financial outcome. */
export function handleLimitChallenge(event, context, refreshSession, setError, refreshCustomer = refreshSession) {
    const { progress, navigation, attemptId } = context;
    if (!progress.verificationFromLimit || attemptId || event.kind === 'ready')
        return false;
    const next = applyChallengeEvent(event);
    if (next.phase === 'requote_required' || next.phase === 'session_refresh_required') {
        returnFromLimitVerification(progress, navigation, attemptId, true);
        if (next.phase === 'session_refresh_required')
            refreshSession();
        else
            refreshCustomer();
        return true;
    }
    if (next.phase === 'verification_pending') {
        returnFromLimitVerification(progress, navigation, attemptId);
        setError('verification_pending');
        return true;
    }
    if (next.phase !== 'connection_required')
        progress.verificationFromLimit = false;
    return false;
}
